import { createContext, useContext } from "react";

import type { AuthZ, PermissionSet } from "./can";

export const AuthZContext = createContext<AuthZ | null>(null);

/** See docs/authz.md Usage → Gate React UI (useAuthZ). Reads AuthZProvider; do not call from the router. */
export function useAuthZ() {
  const context = useContext(AuthZContext);
  if (!context) {
    throw new Error("useAuthZ must be used within AuthZProvider");
  }
  return context.can;
}

/**
 * Router seam, not a UI API — use `useAuthZ()` in components.
 *
 * Exists so route filtering can consume the whole set that `AuthZProvider`
 * already resolved, instead of compiling policy a second time. It is kept off
 * the UI surface for two reasons: `can()` should stay the single vocabulary for
 * gating, and this hands callers a `Set` that is only readonly at compile time.
 */
export function useAuthZPermissions(): PermissionSet {
  const context = useContext(AuthZContext);
  if (!context) {
    throw new Error("useAuthZPermissions must be used within AuthZProvider");
  }
  return context.permissions;
}
